<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:right_view>
      <TsMenuButton ref='tsMenuButton' @methodEnum='methodEnum' ></TsMenuButton>
      <div class="h100-140 h-scroll" style="padding-top: 30px;">
        <CallCountChart ref='callCountChart'></CallCountChart>
      </div>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from '../../layouts/BasicLayout';
import TsMenuButton from '../../components/tsConfig/TsMenuButton';
import CallCountChart from '../../components/tsConfig/CallCountStatistics/CallCountChart';

export default {
  name: 'CallCountStatisticsPage',
  components: {
    BasicLayout,
    TsMenuButton,
    CallCountChart
  },
  data() {
    return {
      left: {
        show: false,
        name: ''
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: `${this.$t('TS.trafficMeasurement')}/${this.$t('TS.callServiceStatistics')}/${this.$t('TS.callCountStatistics')}`
      }
    };
  },
  methods: {
    methodEnum(opcode) {
      switch (opcode) {
        case 'search':
          this.$refs.callCountChart.searchPage();
          break;
        default:
      }
    }
  }
};
</script>

<style scoped>

</style>
